import { Link } from 'react-router-dom';

const FOOTER_LINKS = [
  {
    title: '浏览内容',
    links: [
      { label: '高清电影', to: '/category/movie' },
      { label: '电视剧', to: '/category/tv' },
      { label: '编辑专题', to: '/category/featured' },
      { label: '全部类型', to: '/category/动作' },
    ],
  },
  {
    title: '热门类型',
    links: [
      { label: '动作片', to: '/category/动作' },
      { label: '爱情片', to: '/category/爱情' },
      { label: '科幻片', to: '/category/科幻' },
      { label: '悬疑片', to: '/category/悬疑' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '使用说明', to: '/about' },
      { label: '版权声明', to: '/about' },
      { label: '联系我们', to: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-secondary-950">
                <i className="ri-movie-2-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">中文字幕永久在线</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              专注于为中文用户提供带中文字幕的高清电影与电视剧资源展示与检索体验，内容分类清晰、更新及时，让每一次观影选择都更轻松。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {['ri-weibo-fill', 'ri-wechat-fill', 'ri-youtube-fill', 'ri-telegram-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#social"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-background-200 hover:bg-accent-500 hover:text-secondary-950 transition-colors cursor-pointer"
                  aria-label="社交媒体链接"
                >
                  <i className={`${icon} text-lg`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {FOOTER_LINKS.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading font-semibold text-background-50 text-sm mb-4">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400 text-center sm:text-left">
            © {new Date().getFullYear()} 中文字幕永久在线 · 本站内容均为演示数据，仅供学习交流使用
          </p>
          <p className="text-xs text-background-400">友情链接：影视资源导航 · 观影指南 · 字幕社区</p>
        </div>
      </div>
    </footer>
  );
}